export var GLOBAL = {
    url: 'https://crosscontrol.herokuapp.com/api/',
    ip:'127.0.0.1'
   };
    


// WEBPACK FOOTER //
// ./src/providers/global.ts